module.exports = __webpack_public_path__ + "static/media/Thumbs.9dbd56aa.db";